import { render, staticRenderFns } from "./TransactionTokenTable.vue?vue&type=template&id=69abb1a6&scoped=true"
import script from "./TransactionTokenTable.vue?vue&type=script&lang=js"
export * from "./TransactionTokenTable.vue?vue&type=script&lang=js"
import style0 from "./TransactionTokenTable.vue?vue&type=style&index=0&id=69abb1a6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "69abb1a6",
  null
  
)

export default component.exports